/**
 * AMB-248 — decide how a live-chat message row renders its author avatar.
 *
 * The SignalR `ChatMessage` carries the author's `userImage` (a relative S3
 * key or absolute URL); the call site resolves it to a displayable URL with
 * `getFileUrl` and passes the result here. When there's a usable URL we render
 * a real image; otherwise we fall back to the coloured first-letter badge that
 * the chat used unconditionally before this fix.
 */

export type ChatAvatarSource =
  | { kind: 'image'; uri: string }
  | { kind: 'initial'; letter: string };

export function chatAvatarSource(
  resolvedAvatarUri: string | null | undefined,
  displayName: string | null | undefined,
): ChatAvatarSource {
  if (resolvedAvatarUri) {
    return { kind: 'image', uri: resolvedAvatarUri };
  }
  const local = (displayName ?? '').split('@')[0].trim();
  return { kind: 'initial', letter: (local.charAt(0) || '?').toUpperCase() };
}
